// extracted by mini-css-extract-plugin
export var closeButton = "_28-0";